import Presentation from "./presentation";

const TabContent = ( {
	activeTab,
	isDepleted,
	isLoading,
	list,
	fetchMore,
	updateDeletedPost
} ) => {

	return (
		<Presentation
			activeTab         = { activeTab }
			fetchMore         = { fetchMore }
			isDepleted        = { isDepleted }
			isLoading         = { isLoading }
			list              = { list }
			updateDeletedPost = { updateDeletedPost }
		/>
	);
};

export default TabContent;